import axiosInstance from '@/store/axios'

export default {
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
    // eslint-disable-next-line no-unused-vars
    instances ({ commit }, params) {
      return axiosInstance.get('/api/v1/instances', { params })
        .then((result) => result.data.data)
        .catch((error) => Promise.reject(error))
    },
    // eslint-disable-next-line no-unused-vars
    sourceInstances ({ commit }, params) {
      return axiosInstance.get('/api/v1/source-instances', { params })
        .then((result) => result.data.data)
        .catch((error) => Promise.reject(error))
    },
    // eslint-disable-next-line no-unused-vars
    createSourceInstance ({ dispatch }, sourceInstance) {
      return axiosInstance({
        method: 'POST',
        url: '/api/v1/source-instances',
        data: sourceInstance,
      })
        .then((result) => result.data.data)
        .catch((error) => Promise.reject(error))
    },
    // eslint-disable-next-line no-unused-vars
    updateSourceInstance ({ dispatch }, sourceInstance) {
      return axiosInstance({
        method: 'PATCH',
        url: `/api/v1/source-instances/${sourceInstance.id}`,
        data: sourceInstance,
      })
        .then((result) => result.data.data)
        .catch((error) => Promise.reject(error))
    },
    // eslint-disable-next-line no-unused-vars
    refreshSourceInstance ({ dispatch }, sourceInstance) {
      return axiosInstance({
        method: 'POST',
        url: `/api/v1/source-instances/${sourceInstance.id}/commands/refresh-instance`,
        data: sourceInstance,
      })
        .then((result) => result.data.data)
        .catch((error) => Promise.reject(error))
    },
    // eslint-disable-next-line no-unused-vars
    removeSourceInstance ({ dispatch }, sourceInstance) {
      return axiosInstance({
        method: 'POST',
        url: `/api/v1/source-instances/${sourceInstance.id}/commands/remove-instance`,
      })
        .then((result) => result.data.data)
        .catch((error) => Promise.reject(error))
    },
    // eslint-disable-next-line no-unused-vars
    getSourceInstanceById ({ commit, state }, params) {
      // eslint-disable-next-line consistent-return
      return axiosInstance.get(`/api/v1/source-instances/${params.id}/info`, { params })
        .then((result) => result.data.data)
        .catch((error) => Promise.reject(error))
    },
  },
}
